var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoldOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17V7H12.2994C13.4424 7 14.3093 7.23352 14.9002 7.70055C15.4911 8.163 15.7865 8.84295 15.7865 9.74038C15.7865 10.2303 15.6679 10.663 15.4307 11.0385C15.1935 11.4093 14.8635 11.6818 14.4409 11.8558C14.9239 11.984 15.3035 12.2427 15.5795 12.6319C15.8598 13.0211 16 13.4973 16 14.0604C16 15.022 15.711 15.75 15.1331 16.2445C14.5551 16.739 13.7314 16.9908 12.6617 17H9ZM10.9409 12.6456V15.3448H12.6035C13.0607 15.3448 13.4165 15.2303 13.671 15.0014C13.9298 14.7679 14.0591 14.4473 14.0591 14.0398C14.0591 13.1241 13.6128 12.6593 12.72 12.6456H10.9409ZM10.9409 11.1896H12.3771C13.3561 11.1712 13.8457 10.7569 13.8457 9.94643C13.8457 9.49313 13.7206 9.16804 13.4704 8.97115C13.2246 8.76969 12.8343 8.66896 12.2994 8.66896H10.9409V11.1896Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldOff);
export default __webpack_public_path__ + "static/media/bold_off.719214343efd58d4d65e6ece07c18665.svg";
export { ForwardRef as ReactComponent };